module.exports = __webpack_public_path__ + "static/media/cancelService.1b84d842.svg";